import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./ContractAndConvention.module.sass";
import Card from "../../../components/Card";
import Table from "./Table";
import Panel from "./Panel";

// Services
import { getStudentContractsAndConventions } from "../../../services/contract.service";

const ContractAndFiles = ({ studentId }) => {
    const [contracts, setContracts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedContracts, setSelectedContracts] = useState([]);

    useEffect(() => {
        const fetchContracts = async () => {
            try {
                setLoading(true);
                if (!studentId) {
                    console.log("Pas d'ID d'étudiant disponible");
                    return;
                }
                
                const result = await getStudentContractsAndConventions(studentId);
                
                // Transformer les contrats pour correspondre au format attendu par le composant Table
                const formattedContracts = result.items.map(contract => ({
                    id: contract.id,
                    product: contract.expand?.student_id ? `${contract.expand.student_id.first_name} ${contract.expand.student_id.last_name}` : 'Étudiant non spécifié',
                    link: contract.cerfa_signature_status || 'En attente',
                    date: new Date(contract.start_date_of_contract || contract.created).toLocaleDateString(),
                    price: contract.opco_total_funded_amount || 0,
                    status: contract.opco_status || 'En attente',
                    originalContract: contract // Garder les données originales pour référence
                }));
                
                setContracts(formattedContracts);
            } catch (error) {
                console.error('Erreur lors de la récupération des contrats:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchContracts();
    }, [studentId]);
    
    // Gestion de la sélection des contrats
    const handleSelectContract = (contractId, isSelected) => {
        if (isSelected) {
            // Ajouter le contrat à la sélection
            const contractToAdd = contracts.find(c => c.id === contractId);
            if (contractToAdd) {
                setSelectedContracts([...selectedContracts, contractToAdd.originalContract]);
            }
        } else {
            // Retirer le contrat de la sélection
            setSelectedContracts(selectedContracts.filter(c => c.id !== contractId));
        }
    };
    
    // Sélectionner ou désélectionner tous les contrats
    const handleSelectAll = (isSelected) => {
        if (isSelected) {
            // Sélectionner tous les contrats
            const allOriginalContracts = contracts.map(c => c.originalContract);
            setSelectedContracts(allOriginalContracts);
        } else {
            // Désélectionner tous les contrats
            setSelectedContracts([]);
        }
    };
    
    // Effacer la sélection
    const handleClearSelection = () => {
        setSelectedContracts([]);
    };

    return (
        <>
            <Card
                className={styles.card}
                classCardHead={styles.head}
                title="Contracts"
                classTitle={cn("title-purple", styles.title)}
            >
                <div className={styles.wrapper}>
                    {loading ? (
                        <div className={styles.loading}>Chargement des contrats...</div>
                    ) : contracts.length > 0 ? (
                        <Table 
                            items={contracts} 
                            title="Contrats de l'étudiant" 
                            selectedContracts={selectedContracts.map(c => c.id)}
                            onSelectContract={handleSelectContract}
                            onSelectAll={handleSelectAll}
                        />
                    ) : (
                        <div className={styles.empty}>Aucun contrat trouvé pour cet étudiant</div>
                    )}
                </div>
            </Card>
            <Panel 
                selectedContracts={selectedContracts} 
                onClearSelection={handleClearSelection} 
            />
        </>
    );
};

export default ContractAndFiles;
